import icons from '../../../../../world/spa/libs/icons';

const getWorldIcon = icons.getWorldIcon;

export default {
    namespaced: true,
    state: {
        indexHref: '/',
        appName: 'ANM22 Contacts',
        appLogo: require('../../../../../world/libs/anm22_icons/img/apps/app-contacts.png'),
    },
    getters: {
        HBTheme: state => {
            return {
                appImg: getWorldIcon('contactsIcon'),
                appName: 'ANM22 Contacts',
                appNameColor: "#0aabf4"
            }
        }
    },
    mutations: {
    },
    actions: {
    }
}